import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useAppQuery } from "sprout-graphql";
import { Glitch } from "@sprout/views";
import GlobalContextProviders from "./GlobalContextProviders";
import App from "./App";
const AppQuery = ()=>{
    const { loading , data , error , updateQuery  } = useAppQuery();
    const jumpHistoriesValue = useMemo(()=>{
        var ref;
        return {
            jumpHistories: (data === null || data === void 0 ? void 0 : (ref = data.jumpHistories) === null || ref === void 0 ? void 0 : ref.nodes) || [],
            updateQuery
        };
    }, [
        data,
        updateQuery
    ]);
    if (loading && !data) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!data) return /*#__PURE__*/ _jsx(Glitch, {});
    const { currentUser  } = data;
    return /*#__PURE__*/ _jsx(GlobalContextProviders, {
        currentUserValue: currentUser,
        jumpHistoriesValue: jumpHistoriesValue,
        children: /*#__PURE__*/ _jsx(App, {})
    });
};
export default AppQuery;
